export const IconMobileMenu = ({ color = '#000', width = 20, height = 21 }) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 20 21'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <mask maskUnits='userSpaceOnUse' x='0' y='0' width='20' height='21'>
      <rect y='0.5' width='20' height='20' fill={color} />
    </mask>
    <g mask='url(#mask0_2240_13872)'>
      <path
        d='M3.3335 14.8911V14.0577H16.6668V14.8911H3.3335ZM3.3335 10.9167V10.0834H16.6668V10.9167H3.3335ZM3.3335 6.94231V6.10898H16.6668V6.94231H3.3335Z'
        fill={color}
      />
    </g>
  </svg>
);
